import { removeLoginToken } from '@/modules/login/util'

/**
 * Signs the user out by removing the login token, redirecting to the login page,
 * and optionally invoking a callback function.
 *
 * @param closeCallback - An optional callback function to be executed after the sign-out process.
 */
export const signOut = (closeCallback?: () => void) => {
  removeLoginToken()
  window.location.href = '/login'
  closeCallback && closeCallback()
}
